import { logging } from '../../../logging';

export interface IExternalRedirectProps {
	path: string;
	hostname?: string;
}

export const ExternalRedirect = (props: IExternalRedirectProps) => {
	const url = new URL(window.location.href);

	if (props.hostname) {
		url.hostname = props.hostname;
	}

	url.pathname = props.path.startsWith('/') ? props.path : ('/' + props.path);

	logging.info(`Re-directing to ${url}`);
	window.location.assign(url.href);
	return null;
};
